export interface FaqItem {
  question: string;
  answer: string;
}

export const FAQ_ITEMS: FaqItem[] = [
  {
    question: "Is Tradesfolk really free?",
    answer:
      "Yes, completely. No monthly subscription, no per-lead fees, no premium tier, no credit card required. We make money from partnerships with trade insurance providers, tool suppliers, and other services that tradespeople actually use. You will never pay us a penny to be listed or to receive enquiries.",
  },
  {
    question: "How is this different from Checkatrade?",
    answer:
      'Checkatrade charges tradespeople £70 to £150+ per month for a listing, and many tradespeople report paying over £1,000 a year before they have received a single lead. Tradesfolk is free because we do not charge users. We are funded through partner services. Your profile is not a "paid listing" that disappears when you stop paying.',
  },
  {
    question: "What trades can sign up?",
    answer:
      "We cover over 45 trade categories, from plumbers and electricians to kitchen fitters, roofers, landscapers, and specialist trades like damp proofing and EV charger installation. If your trade is not listed, get in touch and we will add it.",
  },
  {
    question: "How do homeowners find me?",
    answer:
      "Homeowners search by postcode and trade category. If you are within their search radius and cover the trade they need, you appear in their results. They can view your profile, see your work photos, read your reviews, and message you directly. No algorithms hiding you behind paid placements.",
  },
  {
    question: "Can I use Tradesfolk alongside other platforms?",
    answer:
      "Absolutely. Many tradespeople use Tradesfolk alongside Checkatrade, MyBuilder, or their own website. The difference is that Tradesfolk costs you nothing, so there is no downside to having a presence here. Some tradespeople use their Tradesfolk profile as their main online presence because it looks professional and is always free.",
  },
  {
    question: "What if I stop getting work through it?",
    answer:
      "Since there is no subscription, there is nothing to cancel. Your profile stays live as long as you want it there. If you are not getting enquiries, try adding more work photos, collecting reviews from past customers, and making sure your service area is set correctly. The more complete your profile, the more likely homeowners are to get in touch.",
  },
];
